export { default } from './SeoText';
